import { Box } from '@mui/system'
import { loaderStyles as stylesFunction } from 'src/components/shared/ui/Loader/LoaderStyles'

type Props = {
  fullscreen?: boolean
  size?: 'large' | 'medium' | 'small' | 'xsmall'
  transparent?: boolean
  thin?: boolean
}

export default function Loader({
  fullscreen = false,
  size,
  transparent = false,
  thin = false
}: Props): JSX.Element {
  const styles = stylesFunction(fullscreen, transparent)

  function spinnerSize(size) {
    switch (size) {
      case 'large':
        return 'spinner-xl'
      case 'medium':
        return 'spinner-md'
      case 'small':
        return 'spinner-sm'
      case 'xsmall':
        return 'spinner-xs'
      default:
        return 'spinner-md'
    }
  }

  if (fullscreen) {
    return (
      <Box component="div" sx={styles.spinnerContainer}>
        <Box sx={styles.spinnerBackground} />
        <Box
          component="div"
          sx={styles.spinner}
          className={`spinner-border corporativo ${spinnerSize(size)}`}
        />
      </Box>
    )
  }

  return (
    <Box
      component="div"
      sx={thin ? styles.spinnerThin : styles.spinner}
      className={`spinner-border corporativo ${spinnerSize(size)}`}
    />
  )
}
